import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { recentWorks as R } from "../mock";

const RecentWorks = () => {
  return (
    <section id="works" className="bg-[#0b0b0b] text-white py-24 md:py-32 px-5">
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-3">{R.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-5xl md:text-7xl mb-16">{R.title}</h2>
        </Reveal>

        <div className="space-y-8">
          {R.items.map((w, i) => (
            <Reveal key={w.name} delay={i * 0.05}>
              <div className="grid md:grid-cols-2 gap-8 items-center border-t border-white/10 pt-8">
                <div className="order-2 md:order-1">
                  <div className="text-[#8a8a8a] text-sm mb-4">
                    0{i + 1} <span className="mx-1">/</span> 0{R.items.length}
                  </div>
                  <h3 className="font-cal text-4xl md:text-5xl mb-4">{w.name}</h3>
                  <p className="text-[#9a9a9a] max-w-md mb-6">{w.desc}</p>
                  <div className="flex flex-wrap gap-x-10 gap-y-4 text-sm">
                    <div>
                      <div className="text-[#6f6f6f] mb-1">Year</div>
                      <div>{w.year}</div>
                    </div>
                    <div>
                      <div className="text-[#6f6f6f] mb-1">Role</div>
                      <div>{w.role}</div>
                    </div>
                    <div>
                      <div className="text-[#6f6f6f] mb-1">Services</div>
                      <div className="flex flex-wrap gap-2">
                        {w.services.map((s) => (
                          <span key={s} className="bg-white/10 rounded-full px-3 py-1">{s}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <motion.a
                  href="#works"
                  whileHover="hover"
                  className="order-1 md:order-2 group relative block rounded-3xl overflow-hidden"
                >
                  <motion.img
                    src={w.cover}
                    alt={w.name}
                    variants={{ hover: { scale: 1.05 } }}
                    transition={{ duration: 0.6 }}
                    className="w-full h-[280px] md:h-[380px] object-cover"
                  />
                  <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white text-black flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight size={20} />
                  </div>
                </motion.a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentWorks;
